import { render, staticRenderFns } from "./relClientEditDialog.vue?vue&type=template&id=65cd8f64"
import script from "./relClientEditDialog.vue?vue&type=script&lang=js"
export * from "./relClientEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports